module.exports = __webpack_public_path__ + "media/images/emblems/Fechy-coat_of_arms-432257a3b44a00b8b66fc4560b26051e.svg";